var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('configurator',{attrs:{"start-step":1}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }